import { render } from "./BaugrundstueckStep4.vue?vue&type=template&id=0e618a25&scoped=true"
import script from "./BaugrundstueckStep4.vue?vue&type=script&lang=js"
export * from "./BaugrundstueckStep4.vue?vue&type=script&lang=js"

import "./BaugrundstueckStep4.vue?vue&type=style&index=0&id=0e618a25&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e618a25"]])

export default __exports__